import { Box, Typography, Button } from "@mui/material";
import { useState } from "react";
import SummaryInfo from "./SummaryInfo";
import useConfirmPickup from "hooks/pickups/useConfirmPickup";
import { useNavigate } from "react-router-dom";
import useAnalytics from "hooks/analytics/useAnalytics";
import useFeatureFlag from "hooks/useFeatureFlag";
import usePickup from "hooks/pickups/usePickup";
import useLocationInformation from "hooks/locations/useLocationInformation";
import { useAlert } from "hooks/alerts/useAlert";
import { mainContact } from "utils/pickup";
import LegacyPickupRequestConfirmationModal from "./LegacyPickupRequestConfirmationModal";
import NewLogisticsPickupRequestConfirmationModal from "./NewLogisticsPickupRequestConfirmationModal";
import { MISSING_CERTIFICATE_MESSAGE, missingRequiredCertificate } from "./coiRequirement";

export default function Summary() {
  let [open, setOpen] = useState(false);
  const { confirmPickup } = useConfirmPickup();
  const { createAnalyticsEvent } = useAnalytics();
  const { pickup } = usePickup();
  const { locationInformation, isLoading: isLocationInformationLoading } = useLocationInformation(
    pickup?.location?.uuid
  );
  const { alertError } = useAlert();
  const { enabled: newLogisticsPageEnabled } = useFeatureFlag("new_logistics_page_enabled");
  const navigate = useNavigate();
  const mainContactEmail = mainContact(pickup).email;
  const certificateMissing = missingRequiredCertificate({
    option: locationInformation?.coiRequiredOption,
    locationFile: locationInformation?.certificateOfInsuranceFile,
    pickupFile: pickup?.certificateOfInsuranceFile,
  });

  const handleCloseModal = () => {
    setOpen(false);
    navigate("/pickups");
  };

  return (
    <Box mt={3}>
      <Typography variant="h4" fontWeight="bold">
        Pickup Request Summary
      </Typography>
      <Typography mt={1}>Here’s a summary of your pickup request! Review and submit your request below.</Typography>

      <Box mt={6}>
        <SummaryInfo />
      </Box>

      <Box mt={6} sx={{ display: "flex", gap: 2 }}>
        <Button size="large" variant="outlined" onClick={() => navigate(-1)}>
          back
        </Button>
        <Button
          size="large"
          variant="contained"
          disabled={isLocationInformationLoading}
          onClick={() => {
            if (certificateMissing) {
              alertError(MISSING_CERTIFICATE_MESSAGE);
              return;
            }

            setOpen(true);
            confirmPickup();
            createAnalyticsEvent("finish_schedule_pickup");
          }}
        >
          request pickup
        </Button>
      </Box>

      {newLogisticsPageEnabled ? (
        <NewLogisticsPickupRequestConfirmationModal
          open={open}
          onClose={handleCloseModal}
          mainContactEmail={mainContactEmail}
        />
      ) : (
        <LegacyPickupRequestConfirmationModal open={open} onClose={handleCloseModal} />
      )}
    </Box>
  );
}
